export default __webpack_public_path__ + "static/media/christopher_naglieri.8f7071d7.gif";